<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Account</h1>
          <p class="mt-2 text-sm text-gray-700">Details</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
      </div>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">ID</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.id }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Name</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Last logged in</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.last_logged_in }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Last answered</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.last_answered }}</dd>
          </div>

          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-if="isAdmin">
            <dt class="text-sm font-medium leading-6 text-gray-900">Features</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
              <Codemirror
                  v-model:value="account.features"
                  :options="cmOptions"
                  border
                  :height="300"></Codemirror>
            </dd>
          </div>

          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-if="isAdmin">
            <dt class="text-sm font-medium leading-6 text-gray-900">Network</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.network }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-if="isAdmin">
            <dt class="text-sm font-medium leading-6 text-gray-900">Website</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.website }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Created at</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.created_at }}</dd>
          </div>
        </dl>


        <div class="mt-12 mb-2">
          <div class="relative">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex justify-start">
              <span class="bg-white pr-3 text-base font-semibold leading-6 text-gray-900">Additional Information</span>
            </div>
          </div>
        </div>


        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">FCA Firm Reference Number</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.fca_firm_reference_number }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Companies House Number</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.companies_house_number }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Phone Number</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.phone_number }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Location</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.location }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Staff</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.staff }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Client base</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.client_base }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Turnover</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.turnover }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Platform</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.platform }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Compliance Firm</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.compliance_firm }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Practice management (back-office) technology</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.practice_management_technology }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Risk technology</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.risk_technology }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Cashflow technology</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.cashflow_technology }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Firm type</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ account.firm_type }}</dd>
          </div>
        </dl>

      </div>
    </div>
  </div>

  <div class="py-5">
    <UserIndexComponent :accountId="accountId" />
  </div>
</template>

<script>
import UserIndexComponent from "./UserIndexComponent.vue";

export default {
  name: "AccountShowComponent",
  data() {
    return {
      account: {
        id: null,
        name: null,
        last_logged_in: null,
        last_answered: null,
        features: null,
        network: null,
        website: null,
        created_at: null,
      },
      cmOptions: {
        mode: "application/json",
        readOnly: true,
      },
    }
  },
  components: {
    UserIndexComponent,
  },
  computed: {
    accountId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
    isAdmin() {
      return this.$store.state.userIsAccountLevelAdmin;
    },
  },
  methods: {
    getAccount() {
      axios.get(`/member-firm/accounts/show/${this.accountId}`).then((res) => {
        this.account = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    cancel() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.accountId) {
      this.getAccount();
    }
  }

}
</script>